<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/components/Dir'

    export default {
        components: {
            Grid,
        }
    }
</script>